import { Matrix } from 'app/models/questions/Matrix'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { ImageComponent } from 'app/modules/survey/survey-viewer/survey-question/types/image/image.component'
import { ImagePropertyValidator } from 'app/models/questions/property-validator/ImagePropertyValidator'
import { IImage } from 'app/interfaces/IImage'
import { IImageSelection } from 'app/interfaces/IImageSelection'
import { requireMinImageSelection } from 'app/form-validators/RequireMinImageSelectionValidator'
import { AbstractControl, UntypedFormGroup } from '@angular/forms'

export class Image extends Matrix implements IImage {
  private readonly _imageSelection: IImageSelection

  constructor(question) {
    super(question)

    this._imageSelection = question.imageSelection

    new ImagePropertyValidator(question).validate()
  }

  getDisplayComponent() {
    return new QuestionComponent(ImageComponent, this)
  }

  applyMaxAnswers(surveyForm) {
    return this.limitAnswersAmount
  }

  isOpenStatement(rowKey, statementKey) {
    if (this.rows[rowKey].isOpen) {
      return true
    }

    return this.rows[rowKey].openCols[statementKey]
  }

  getOpenStatementsForRow(rowKey: string): string[] {
    return this.rows[rowKey].isOpen ? this.statementKeys : []
  }

  buildFormGroupValidators() {
    return this.isOptional ? [] : [requireMinImageSelection(this)]
  }

  selectImage(statementKey: string, questionForm: AbstractControl): boolean {
    let previouslySelectedImageCount = 0
    let rowKeyOfNewlySelectedImage = null
    let selectedStatements = {}
    this.rowsOrder.forEach(rKey => {
      const aRow = questionForm.get(rKey).get(this.formControlName).value;
      selectedStatements[rKey] = Object.entries(aRow).find(a => a[1])?.[0];
      if (aRow[statementKey]) {
        rowKeyOfNewlySelectedImage = rKey
        delete selectedStatements[rKey]
      }
    })
    previouslySelectedImageCount = Object.values(selectedStatements).filter(Boolean).length

    if (previouslySelectedImageCount === this.rowsOrder.length && !rowKeyOfNewlySelectedImage) {
      return false
    }

    if (rowKeyOfNewlySelectedImage) {
      this.resetQuestionForm(questionForm)

      const selectStatementValues: string[] = Object.values(selectedStatements)
      for (let i = 0; i < Object.keys(selectedStatements).length; i++) {
        questionForm.get(this.rowsOrder[i]).get(this.formControlName).get(selectStatementValues[i]).setValue(true)
      }

    } else {
      questionForm.get(this.rowsOrder[previouslySelectedImageCount]).get(this.formControlName).get(statementKey).setValue(true)
    }

    return true
  }

  addAvailableControlsForRow(statementKeys: string[], surveyForm: UntypedFormGroup, rKey: string, availableControls: {}) {
    statementKeys.forEach(sKey => {
      surveyForm.controls[this.key].get(rKey).get(this.formControlName).get(sKey).updateValueAndValidity()
      if (
        surveyForm.controls[this.key].get(rKey).get(this.formControlName).get(sKey).enabled &&
        !availableControls[sKey] &&
        !this.findRowKeyOfSelectedImage(sKey, surveyForm.controls[this.key])
      ) {
        availableControls[sKey] = true
      }
    })
  }

  findRowKeyOfSelectedImage(statementKey: string, formControl: AbstractControl): string {
    let rowKey = ''

    for (const rKeyIdx in this.rowKeys) {
      const rKey = this.rowKeys[rKeyIdx]
      if (formControl.get(rKey).get(this.formControlName).get(statementKey).value) {
        rowKey = rKey
        break
      }
    }

    return rowKey
  }

  private resetQuestionForm(questionForm: AbstractControl) {
    let resetValue = {}
    this.rowsOrder.forEach(rKey => {
      resetValue[rKey] = {
        [this.formControlName]: {},
        [this.commentsControlName]: {}
      }
      this.statementKeys.forEach(sKey => {
        resetValue[rKey][this.formControlName][sKey] = false
        resetValue[rKey][this.commentsControlName][sKey] = ''
      })
    })
    questionForm.reset(resetValue, {emitEvent: false})
  }

  get imageSelection() {
    return this._imageSelection
  }
}
